// Rangos de referencia — LeagueRangesTable íntegra (95 ligas P33/P66),
// con selector de liga (en el dashboard vive dentro del detalle de partido).
import { useState } from 'react';
import LeagueRangesTable from '../../components/LeagueRangesTable';
import leagueThresholds from '../../config/leagueThresholds.json';

export default function Rangos() {
  const ligas = leagueThresholds.map((e) => e.liga).sort((a, b) => a.localeCompare(b, 'es'));
  const [liga, setLiga] = useState(ligas[0] || '');
  return (
    <div className="app-scroll">
      <div className="app-pgh" style={{ paddingTop: 'calc(16px + env(safe-area-inset-top))' }}>
        <h1>Rangos de referencia</h1>
        <p>Umbrales P33/P66 por liga ({ligas.length} ligas calibradas) — los mismos del análisis del motor.</p>
      </div>
      <div className="app-fld" style={{ marginBottom: 14 }}>
        <p className="l">Liga</p>
        <div className="row">
          <select value={liga} onChange={(e) => setLiga(e.target.value)}
            style={{ width: '100%', border: 'none', outline: 'none', background: 'transparent', fontFamily: 'inherit', fontSize: 15.5, fontWeight: 500, color: 'var(--ink)' }}>
            {ligas.map((l) => <option key={l} value={l}>{l}</option>)}
          </select>
        </div>
      </div>
      <LeagueRangesTable liga={liga} values={{}} />
    </div>
  );
}
